import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useState, useEffect } from "react";
import { Paper } from "@mui/material";
import axios from "axios";
import AuthHeader from "../../../../Auth";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import {
  Grid,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  TablePagination,
  Typography,
} from "@mui/material";
import axiosInstance from "../../../../lib/axios";

const UserStep2 = ({
  UserId,
  fetchUserData,
  handleStepClick,
  AllTextDisabled,
  setAllTextDisabled,
  setAllButtonDisabled,
  UserLoginId,
}) => {
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 25,
  });
  const [selectionModel, setSelectionModel] = React.useState([]);
  const [PropertyDrpData, setPropertyDrpData] = useState([]);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await fetchPropertyData();
        await fetchUserPropertyData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [UserId]);

  useEffect(() => {
    if (PropertyDrpData.length > 0) {
      let newData = PropertyDrpData.map((obj) => {
        return {
          id: obj.Id, // Ensure the field 'id' matches the DataGrid's row ID
          Name: obj.Name,
          NameCode: obj.NameCode,
          Text: obj.Text,
          SearchText: obj.SearchText,
          Value: obj.Value,
        };
      });
      setRows(newData);
    }
  }, [PropertyDrpData]);

  const fetchPropertyData = async () => {
    try {
      const response = await axiosInstance.post(
        `PropertyMst/getPropertyMstdrp`, "",
      );
      if (response.data.Status === 0) {
        setPropertyDrpData(response.data.Data);
      } else {
        toast.error("Error fetching property data");
      }
    } catch (error) {
      toast.error("Error fetching property data");
    }
  };

  // Fetch user property data
  const fetchUserPropertyData = async () => {
    if (UserId !== -1) {
      try {
        const response = await axiosInstance.post(
          `UserMst/GetMstUserPropDashBoard`,
          { UserId },
        );
        if (response.data.Data != null) {
          let resLength = response.data.Data.length;
          let arrOfId = [];
          let resData = response.data.Data;
          for (let i = 0; i < resLength; i++) {
            arrOfId.push(resData[i].PropId);
          }
          setSelectionModel(arrOfId);
        }
      } catch (error) {
        toast.error("Error fetching user property data");
      }
    }
  };

  const handleSelectionChange = (newSelectionModel) => {
    setSelectionModel(newSelectionModel);
  };

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "Name", headerName: "Name", width: 200 },
    { field: "NameCode", headerName: "Total Rooms", width: 120 },
    { field: "Text", headerName: "Total Beds", width: 120 },
    { field: "SearchText", headerName: "Sqft", width: 120 },
    { field: "Value", headerName: "Mobile", width: 120 },
  ];

  const handleNextClick = () => { };

  const handleClickSubmit = async () => {
    let data = [];
    for (let i = 0; i < selectionModel.length; i++) {
      data.push({ UserId, PropId: selectionModel[i] });
    }
    if (data.length === 0) {
      data.push({ UserId, PropId: 1 });
    }
    let sendObj = { UserProp: data };
    let FormattedObj = JSON.stringify(sendObj).replace(/"/g, '\\"');
    FormattedObj = '"' + FormattedObj + '"';
    try {
      const response = await axiosInstance.post(
        `UserMst/ManageMstUserProp`,
        FormattedObj,
      );
      if (response.data.Status === 0) {
        toast.success(response.data.Message, { autoClose: 1000 });
        setAllTextDisabled((prev) => !prev);
        setAllButtonDisabled((prev) => !prev);
        setTimeout(() => {
          fetchUserData(UserId, "R");
          handleStepClick(0);
        }, 1800);
      } else {
        toast.error("Error To Insert property data");
      }
    } catch (error) {
      toast.error("Error To Insert property data");
    }
  };

  const handleCancel = () => {
    setAllTextDisabled((prev) => !prev);
    setAllButtonDisabled((prev) => !prev);
    handleStepClick(0);
  };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "center" }}>
        {/* <ToastContainer /> */}
        <Paper sx={{ height: 240, width: "65%" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            pageSize={paginationModel.pageSize}
            page={paginationModel.page}
            onPageChange={(newPage) =>
              setPaginationModel((prev) => ({ ...prev, page: newPage }))
            }
            onPageSizeChange={(newPageSize) =>
              setPaginationModel((prev) => ({ ...prev, pageSize: newPageSize }))
            }
            pagination
            checkboxSelection
            onRowSelectionModelChange={(newRowSelectionModel) => {
              handleSelectionChange(newRowSelectionModel);
            }}
            rowSelectionModel={selectionModel}
            rowHeight={30}
            columnHeaderHeight={30}
            sx={{
              border: 0,
              pointerEvents: "auto",
            }}
          />
        </Paper>
      </div>
      <Grid item xs={12} className="form_button" sx={{ marginTop: "10px" }}>
        <Button
          variant="contained"
          size="small"
          sx={{
            mr: 1,
            background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)",
          }}
          onClick={handleClickSubmit}
          disabled={AllTextDisabled}
        >
          submit
        </Button>
        <Button
          variant="contained"
          size="small"
          sx={{
            mr: 1,
            background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)",
          }}
          onClick={handleCancel}
          disabled={AllTextDisabled}
        >
          Cancel
        </Button>
      </Grid>
    </>
  );
};

export default UserStep2;
